import { Link } from "react-router";
import { all_routes } from "../../../../router/all_routes";

interface Props {
    activeTab:  'TokenSettings' | 'TokenTopup' | 'TokenUsage' | 'TokenTopupHistory';
}

const SettingsMenu = ({activeTab}:Props) => {
    const routes = all_routes;


    return (
        <>
            <Link
                to={routes.sgSettings}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'TokenSettings' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Settings
            </Link>
            <Link
                to={routes.sgTokenUsage}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'TokenUsage' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Usage
            </Link>
            <Link
                to={routes.sgTopupSettings}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'TokenTopup' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Topup
            </Link>
            <Link
                to={routes.sgTopupHistory}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'TokenTopupHistory' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Topup History
            </Link>
        </>
    )
}

export default SettingsMenu;